import React, {useState, useEffect} from "react";
import {Checkbox, DatePicker, Input, List, Pagination, Space, Spin} from "antd";
import {CaretDownFilled, SearchOutlined, LoadingOutlined} from "@ant-design/icons";
import FilterBullet from "../../../helpers/components/filter_bullet";
import CustomerService from "../../../services/ewallet_integration/customer.service";
import dayjs from "dayjs";

const {RangePicker} = DatePicker;

const DatePickerFilter = ({filter = {}, changeDate,}) => {
    const [localState, setLocalState] = useState({
        loading: false,
        transaction_type: [],
    });

    return (
        <>
            <FilterBullet
                popover={
                    <>
                        <div>
                            <RangePicker
                                {...(filter?.start_date && filter?.end_date) && ({defaultValue: [dayjs(filter?.start_date), dayjs(filter?.end_date)]})}
                                // disabled={ticketRedux?.list_loading}
                                onChange={(e) => changeDate('start_date', 'end_date', e)} format={"YYYY-MM-DD"}
                            />
                        </div>
                    </>
                }
            >
                <div>
                    <Space>
                        <div>
                            <span>Date
                                <span style={{
                                    fontSize: 12,
                                    fontWeight: 500,
                                    color: 'var(--secondary-text-color)'
                                }}>
                                    {filter?.start_date && filter?.end_date && `: ${filter?.start_date}-${filter?.end_date}`}
                                </span>
                            </span>
                        </div>
                        <div>
                            <CaretDownFilled style={{color: '#a0aec0'}}/>
                        </div>
                    </Space>
                </div>
            </FilterBullet>
        </>
    );
};

export default DatePickerFilter;
